// Visit cards (stories/story-202609271055-visit-cards-mvp.md). A fetch client
// of its own rather than utils' XHR helpers: the screens need the status and
// the server's `reason` for a refusal, and an XHR's statusText is empty over
// HTTP/2.
import { HOST } from './index'

export class CardsApiError extends Error {
    constructor(status, body) {
        super((body && body.reason) || `HTTP ${status}`)
        this.status = status
        this.reason = (body && body.reason) || null
        this.details = body || {}
    }
}

const call = async (method, path, body) => {
    const response = await fetch(HOST + '/api/admin/cards' + path, {
        method,
        headers: {
            'Content-Type': 'application/json',
            new_access_token: localStorage.getItem('accessToken'),
        },
        body: body === undefined ? undefined : JSON.stringify(body),
    })
    const text = await response.text()
    let data = null
    try {
        data = text ? JSON.parse(text) : null
    } catch (e) {
        data = null
    }
    if (!response.ok) throw new CardsApiError(response.status, data)
    return data
}

export const listCardTypes = siteId => call('GET', `/types/${siteId}`)
export const createCardType = (siteId, type) => call('POST', `/types/${siteId}`, type)
export const updateCardType = (siteId, typeId, type) => call('PUT', `/types/${siteId}/${typeId}`, type)
export const archiveCardType = (siteId, typeId, archived) => call('POST', `/types/${siteId}/${typeId}/archive`, { archived })

export const listCardBatches = siteId => call('GET', `/batches/${siteId}`)
export const createCardBatch = (siteId, batch) => call('POST', `/batches/${siteId}`, batch)
export const readCardBatch = (siteId, batchId) => call('GET', `/batches/${siteId}/${batchId}`)

export const readCardByCode = code => call('GET', `/by-code/${encodeURIComponent(code)}`)
export const listCards = siteId => call('GET', `/${siteId}`)
export const sellCard = (siteId, sale) => call('POST', `/${siteId}`, sale)
export const activateCard = (siteId, cardId, sale) => call('POST', `/${siteId}/${cardId}/activate`, sale)
export const readCard = (siteId, cardId) => call('GET', `/${siteId}/${cardId}`)
export const cardDayBookings = (siteId, cardId, date) => call('GET', `/${siteId}/${cardId}/day/${date}`)
export const topUpCard = (siteId, cardId, dates) => call('POST', `/${siteId}/${cardId}/topup`, dates)
export const adjustCard = (siteId, cardId, correction) => call('POST', `/${siteId}/${cardId}/adjust`, correction)
export const cancelCard = (siteId, cardId, reason) => call('POST', `/${siteId}/${cardId}/cancel`, { reason })
export const replaceCardCode = (siteId, cardId, reason) => call('POST', `/${siteId}/${cardId}/code`, { reason })
export const setCardClients = (siteId, cardId, clientIds) => call('PUT', `/${siteId}/${cardId}/clients`, { clientIds })
export const redeemCard = (siteId, cardId, redemption) => call('POST', `/${siteId}/${cardId}/redeem`, redemption)
export const reverseRedemption = (siteId, cardId, entryId, reason) => call('POST', `/${siteId}/${cardId}/reverse/${entryId}`, { reason })
export const dayRedemptions = (siteId, date) => call('GET', `/${siteId}/redemptions/${date}`)
